import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import CompleteGuide from "@/pages/guide/oopbuy-spreadsheet-complete-guide/page";
import BeginnersGuide from "@/pages/guide/oopbuy-spreadsheet-beginners-guide/page";
import VsTraditionalTools from "@/pages/guide/oopbuy-spreadsheet-vs-traditional-tools/page";
import AutomationStrategies from "@/pages/guide/oopbuy-spreadsheet-automation-strategies/page";
import BestPractices from "@/pages/guide/oopbuy-spreadsheet-best-practices/page";
import FashionCategories from "@/pages/guide/oopbuy-spreadsheet-fashion-categories/page";
import DataDrivenDecisions from "@/pages/guide/oopbuy-spreadsheet-data-driven-decisions/page";
import ComparisonMethodology from "@/pages/guide/oopbuy-spreadsheet-comparison-methodology/page";
import SaveTimeMoney from "@/pages/guide/oopbuy-spreadsheet-save-time-money/page";
import AdvancedTechniques from "@/pages/guide/oopbuy-spreadsheet-advanced-techniques/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/guide/oopbuy-spreadsheet-complete-guide", element: <CompleteGuide /> },
  { path: "/guide/oopbuy-spreadsheet-beginners-guide", element: <BeginnersGuide /> },
  { path: "/guide/oopbuy-spreadsheet-vs-traditional-tools", element: <VsTraditionalTools /> },
  { path: "/guide/oopbuy-spreadsheet-automation-strategies", element: <AutomationStrategies /> },
  { path: "/guide/oopbuy-spreadsheet-best-practices", element: <BestPractices /> },
  { path: "/guide/oopbuy-spreadsheet-fashion-categories", element: <FashionCategories /> },
  { path: "/guide/oopbuy-spreadsheet-data-driven-decisions", element: <DataDrivenDecisions /> },
  { path: "/guide/oopbuy-spreadsheet-comparison-methodology", element: <ComparisonMethodology /> },
  { path: "/guide/oopbuy-spreadsheet-save-time-money", element: <SaveTimeMoney /> },
  { path: "/guide/oopbuy-spreadsheet-advanced-techniques", element: <AdvancedTechniques /> },
  { path: "*", element: <NotFound /> },
];

export default routes;